<template>
	<div class="m-flow-scroll">
		<div class="m-flow flex-column flex-center">
			<div class="flex-center" style="gap: 46px;">
				<div class="flow mini flex-column flex-center" @click="$emit('route', 'm_stockin')">
					<i class="tf">&#xe752;</i>
					<p>入库单</p>
				</div>
				<div class="flow mini flex-column flex-center" @click="$emit('route', 'm_stockout')">
					<i class="tf">&#xe753;</i>
					<p>出库单</p>
				</div>
				<div class="flow mini flex-column flex-center" @click="$emit('route', 'm_inventory')">
					<i class="tf">&#xe772;</i>
					<p>盘点单</p>
				</div>
			</div>

			<flow-arrow width="356" height="31" :lines="[
				'45,0 45,30 178,30',
				'178,0 178,30',
				'311,0 311,30 178,30'
			]"></flow-arrow>

			<flow-arrow width="356" height="40" dashed color="#999" :arrow="[
				'178,0 178,30'
			]"></flow-arrow>

			<div class="box flex-wrap">
				<div class="branch flex-center" @click="$emit('route', 'm_stock_record')">
					<p>库存收发明细</p>
				</div>
				<div class="branch flex-center" @click="$emit('route', 'm_stock')">
					<p>库存余额</p>
				</div>
				<div class="branch flex-center" @click="$emit('route', 'm_stock_detail')">
					<p>库存余额明细</p>
				</div>
				<div class="branch flex-center" @click="$emit('route', 'm_stock_summary')">
					<p>进销存汇总</p>
				</div>
				<div class="branch flex-center" @click="$emit('route', 'm_stock_change_record')">
					<p>库存变更记录</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import flowArrow from './flow_arrow.vue'

	export default {
		components: {
			flowArrow
		},

		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	@import './flow'

	.box {
		row-gap: 10px;
		column-gap: 12px;
		box-sizing: border-box;
		width: 360px;
		border: 1px dashed #0D6EFE;
		padding: 15px 17px;
		background: #F2F7FE;

		.branch {
			width: 100px;
		}
	}
</style>